import React from 'react'
import Approvedlist from './component/approvedList/approvedlist'
import NavbarUser from '../../components/navbar/NavbarUser'
import PageHeader from '../../components/pageheader/PageHeader';
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
function ApproveList() {
  return (
    <div>
      <NavbarUser />
      <main className="container mx-auto px-4 py-8" style={{ padding: 10, backgroundColor: '#f7f7f7' }}>
        <PageHeader
          title="Workflow Pre Approved List"
          subtitle="Manage document workflow"
          icon={AssignmentTurnedInRoundedIcon}
          color="#ef6c00"
        />
        <div>
          <Approvedlist />
        </div>
      </main>
    </div>
  )
}

export default ApproveList